import {IPoint} from '../interfaces/primitives/IPoint';

export class Conversion
{
    /**
     * Конвертим объект с однотипными свойствами в карту указателей
     * @param object - объект со свойствами данного типа
     * @returns карта указателей
     */
    static ObjectWithKeysToMap<U>(object: {[key: string]: U}): Map<string, U> {
        let map: Map<string, U> = new Map<string, U>();
        for (let key in object) {
            map.set(key, object[key]);
        }
        return map;
    }

    static polarToOrthogonal(corner: number, radius: number): IPoint {
        return {x: Math.cos(corner) * radius, y: Math.sin(corner) * radius};
    }

    static degreesToRadians(degrees: number): number {
        return degrees / 180 * Math.PI;
    }
}
